import { LOCATION_TYPE_TITLE } from '@/types/models/Location.model'

import { BreadCrumb } from '@/types/models/Location.model'
import { DISALLOWED_LOCATION_TYPES } from '../location/constants'

export const filterBreadcrumbsForDisallowedRegions = (
  breadcrumbs: BreadCrumb[]
): BreadCrumb[] => {
  return breadcrumbs.filter(
    (breadcrumb) =>
      !DISALLOWED_LOCATION_TYPES.includes(
        breadcrumb.type as LOCATION_TYPE_TITLE
      )
  )
}
